<template>
  <v-card class="pa-1 max-shadow">
    <v-list>
      <v-list-tile avatar>
        <v-list-tile-avatar>
          <avatar
            :text="poll.author.name"
            :size="40"
            :src="poll.author.photo"
          />
        </v-list-tile-avatar>
        <v-list-tile-content>
          <v-list-tile-title>
            <span class="body-2">
              {{ poll.author.name }} created a poll
            </span>
          </v-list-tile-title>
          <v-list-tile-sub-title>
            <span class="caption">
              {{ formatTime(poll.createdAt) }}
            </span>
          </v-list-tile-sub-title>
        </v-list-tile-content>
        <v-list-tile-action>
          <v-btn
            color="primary"
            icon
            flat
            @click="$emit('delete', poll)"
          >
            <v-icon>delete</v-icon>
          </v-btn>
        </v-list-tile-action>
      </v-list-tile>
      <v-card-title class="px-2 py-1 body-1">
        {{ poll.content.title }}
      </v-card-title>
      <v-container grid-list-md>
        <v-layout
          v-for="option in poll.content.options"
          :key="option.key"
          wrap
          row
          align-center
        >
          <v-flex xs12>
            <span
              class="subheading black--text"
            >
              {{ option.name }}
            </span>
          </v-flex>
          <v-flex xs12>
            <v-progress-linear
              active
              color="accent"
              class="ma-0"
              height="35px"
              style="border-radius:9px"
              :value="getProgressbarValue(option.voters)"
            >
              <div
                style="height:35px;
                    display: flex;
                    align-items: center;
                    margin: 0 8px;"
              >
                {{ getVoters(option.voters) }} Votes
              </div>
            </v-progress-linear>
          </v-flex>
        </v-layout>
      </v-container>
      <v-card-actions>
        <span class="body-1 pr-3">
          {{ likes }}
          <v-icon small>
            mdi-heart-outline
          </v-icon>
        </span>
        <span>
          {{ noOfComments }}
          <v-icon
            small
            @click="showPoll"
          >
            mdi-comment-outline
          </v-icon>
        </span>
      </v-card-actions>
    </v-list>
    <comments
      v-if="showComments"
      :feed-id="poll.id"
    />
  </v-card>
</template>
<script>
import Avatar from '@/components/common/Avatar';
import * as moment from 'moment';
import _get from 'lodash/get';
import Comments from './Comments';

export default {
  name: 'Poll',
  components: {
    avatar: Avatar,
    comments: Comments
  },
  props: {
    poll: {
      type: Object,
      required: true,
      default: () => {}
    },
    showComments: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {};
  },
  computed: {
    noOfComments() {
      const comments = _get(this.poll, 'comments');
      return comments ? comments.length : 0;
    },
    likes() {
      const likes = _get(this.poll, 'likes');
      return likes ? likes.length : 0;
    },
    totalVotes() {
      if (!this.poll) return;
      const options = _get(this.poll, 'content.options');
      let totalVotes = 0;
      Object.keys(options).forEach(key => {
        const value = options[key];
        const votes = value.voters ? value.voters.length : 0;
        totalVotes = totalVotes + votes;
      });
      return totalVotes;
    }
  },
  methods: {
    formatTime(timestamp) {
      const date = timestamp.toDate();
      const today = moment().startOf('day');
      return moment(date).isAfter(today)
        ? moment(date).fromNow()
        : moment(date).calendar(today, {
            lastWeek: 'DD MMM [at] hh:mm A',
            sameElse: 'DD MMM [at] hh:mm A'
          });
    },
    showPoll() {
      if (this.noOfComments === 0) return;
      this.$emit('show-comments', this.poll);
    },
    getVoters(votersArray) {
      if (!votersArray) return 0;
      const voters = votersArray.length;
      return voters;
    },
    getProgressbarValue(votersArray) {
      if (!votersArray) return 0;
      const voters = votersArray.length;
      if (voters === 0) return 0;
      const outOfOne = voters / this.totalVotes;
      return outOfOne * 100;
    }
  }
};
</script>
